import { breakpoints } from 'styles';
import { useReduxState } from 'hooks';
import { Link } from 'components/common';

const HeaderLogo = () => {
  const { language, pageState, serverConfig, theme, user } = useReduxState();

  const anchorAttrs = { className: 'logo-link' } as { [key: string]: string };

  if (serverConfig?.courseLoginLogoHref) {
    anchorAttrs.href = serverConfig.courseLoginLogoHref;
    anchorAttrs.target = '_blank';
    anchorAttrs.rel = 'noopener noreferrer';
  }

  const logoWidth =
    theme.logoWidthLanguageVariants?.[language] || theme.logoWidth;

  const children = (
    <>
      {theme.mobileLogo ? (
        <img
          alt="logo"
          className="logo-img-mobile"
          src={theme.mobileLogo}
          style={{
            maxWidth: theme.mobileLogoWidth || logoWidth,
            width: theme.mobileLogoWidth || logoWidth
          }}
        />
      ) : null}

      <img
        alt="logo"
        className="logo-img"
        src={theme.logoLanguageVariants?.[language] || theme.logo}
        style={{ maxWidth: logoWidth, width: logoWidth }}
      />

      <style jsx>{`
        .logo-link {
          display: inline-block;
        }
        .logo-img,
        .logo-img-mobile {
          display: block;
          padding: 0;
        }
        .logo-img-mobile + .logo-img {
          display: none;
        }
        @media (min-width: ${breakpoints.small}px) {
          .logo-img-mobile {
            display: none;
          }
          .logo-img-mobile + .logo-img {
            display: block;
          }
        }
      `}</style>
    </>
  );

  if (
    serverConfig?.courseLoginLogoHref ||
    (user?.roles.includes('guest') && !serverConfig.accountGuestEnableHomePage)
  ) {
    return <a {...anchorAttrs}>{children}</a>;
  }

  return (
    <div style={{ display: 'flex' }}>
      <Link
        href={pageState?.courseLogin ? `/login/${pageState.course.slug}` : '/'}
        {...anchorAttrs}
      >
        {children}
      </Link>
    </div>
  );
};

export default HeaderLogo;
